<div class="ui-g-12">
    <div class="subtitle">
      <div class="campaign-coupon-sub">{{ 'campaign.stretchUpsell' | translate }}</div>
    </div>
    <div class="ui-g-8">
      <p-slider [style]="{'background-size':'100% 40px'}" [min]="coupon.stretch_min" [max]="coupon.stretch_max" [step]="coupon.passo_stretch" [(ngModel)]="coupon.stretch" (onChange)="changeCouponSettings()"></p-slider>
      <ol class="list-unstyled step-indicator step-indicator-horizontal step-indicator-xs">
        <li *ngFor="let percentage of coupon.stretch_slider; let i = index;">
          <ng-container [ngSwitch]="i">
            <div class="caption" *ngSwitchCase="0">{{ percentage | number:'.0-1' }}%</div>
            <div class="caption" *ngSwitchCase="1" style="margin-left: 10px;">{{ percentage | number:'.0-1' }}%</div>
            <div class="caption" *ngSwitchCase="2" style="text-align: center">{{ percentage | number:'.0-1' }}%</div>
            <div class="caption" *ngSwitchCase="3" style="text-align: right; margin-right: 10px;">{{ percentage | number:'.0-1' }}%</div>
            <div class="caption" *ngSwitchCase="4" style="text-align: right">{{ percentage | number:'.0-1' }}%</div>
          </ng-container>
        </li>
      </ol>
    </div>
    <div class="ui-g-4">
      <p-spinner class="slider-field" size="5" [min]="coupon.stretch_min" [max]="coupon.stretch_max" [step]="coupon.passo_stretch" [(ngModel)]="coupon.stretch" (onChange)="changeCouponSettings()"></p-spinner>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-2/coupon-slider-2.component.html